import { render } from "./PODetail.vue?vue&type=template&id=77268272"
import script from "./PODetail.vue?vue&type=script&lang=js"
export * from "./PODetail.vue?vue&type=script&lang=js"
script.render = render

export default script